import React, { useEffect } from "react";
import Navbar from "../navbar/navbar";
import "./privacy.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "./Footer";
const Privacy = () => {
  useEffect(() => {
    AOS.init(); //You can add options as per your need inside an object
  }, []);
  return (
    <>
      <Navbar />
      <div style={{background:"white"}}>
        <div>
          <div
            className="container-fluid"
            style={{ paddingRight: "26px", paddingLeft: "26px" }}
          >
            <div className="row" style={{ paddingBottom: " 0px" }}>
              <div
                className="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2"
                style={{ marginTop: " 20px" }}
              >
                <div className="intro"></div>
                <div className="text">
                  <p
                    className="text-start"
                    data-aos="fade-up"
                    style={{
                      fontFamily: "Montserrat, sans-serif",
                      lineHeight: "20px",
                      fontSize: " 14px",
                      padding:"4% 17% 0 17%",
                    }}
                  >
                    <div style={{fontFamily: "Montserrat, sans-serif"}}>

                    <strong>PRIVACY POLICY</strong>
                    <br />
                    <br />
                    <strong>Last&nbsp;updated&nbsp;May 07, 2022</strong>
                    <br />
                    <br />
                    <strong>
                      This privacy notice for&nbsp;Minus Zero Robotics Private
                      Limited&nbsp;(doing business as&nbsp;Minus Zero)&nbsp;
                    </strong>
                      ("
                    <strong>Minus&nbsp;Zero</strong>," "<strong>we</strong>," "
                    <strong>us</strong>," or "<strong>our</strong>"),<strong> describes
                    how and why we might collect, store, use, and/or share </strong> ("
                    <strong>process</strong>") your information when you use our
                    services ("<strong>Services</strong>"), such as when you:
                    <br />
                    <br />
                    <strong>•</strong>&nbsp;Visit our website&nbsp;at&nbsp;
                    <a href="https://minuszero.in/" target="_blank">
                      https://minuszero.in
                    </a>
                    , or any website of ours that links to this privacy notice.
                    <br />
                    <strong>•</strong>&nbsp;Engage&nbsp;with us in other related
                    ways, including any collaborations, sales, marketing, or
                    events.
                    <br />
                    <br />
                    By using the Service, you agree to the collection and use of
                    information in accordance with this Privacy Policy.
                    <br />
                    <br />
                    <strong>Questions&nbsp;or concerns?&nbsp;</strong>Reading
                    this privacy notice will help you understand your privacy
                    rights and choices. If you do not agree with our policies
                    and practices, please do not use our Services. If you still
                    have any questions or concerns, please contact us at&nbsp;
                    <a href="mailto:team@minuszero.in">
                      team@minuszero.in
                    </a>. <br />
                    <br />
                    <strong>1. WHAT INFORMATION DO WE COLLECT?</strong>
                    <br />
                    <br />
                    <strong>
                      Personal information you disclose&nbsp;to us
                    </strong>
                    <br />
                    <br />
                    We collect personal information that you voluntarily provide
                    to us when you&nbsp;express an interest in obtaining
                    information about us or our products and Services, when you
                    participate in activities on the Services, or otherwise when
                    you contact us.
                    <br />
                    <br />
                    <strong>Personal Information Provided by&nbsp;You.</strong>
                    &nbsp;The personal information that we collect depends on
                    the context of your interactions with us and the Services,
                    the choices you make, and the products and features you use.
                    The personal information we collect may include the
                    following:
                    <br />
                    <br />
                    <strong>•</strong>&nbsp;Name
                    <br />
                    <strong>•</strong>&nbsp;E-mail
                    <br />
                    <strong>•</strong>&nbsp;ID
                    <br />
                    <strong>•</strong>&nbsp;Any other information that you may
                    choose to disclose voluntarily which contacting/interacting
                    with us through any means including but not limited to
                    contact form or email. <br />
                    <br />
                    <strong>Sensitive&nbsp;Information.</strong>&nbsp;We do not
                    process sensitive information.
                    <br />
                    <br />
                    All personal information that you provide to us must be
                    true, complete, and accurate, and you must notify us of any
                    changes to such personal information.
                    <br />
                    <br />
                    <strong>2. HOW DO WE PROCESS YOUR&nbsp;INFORMATION?</strong>
                    <br />
                    <br />
                    <strong>
                      We process your personal&nbsp;information for a variety of
                      reasons, depending on how you interact with
                      our&nbsp;Services, including:
                    </strong>
                    <br />
                    <br />
                    <strong>
                      To&nbsp;respond to user inquiries/offer support to
                      users.&nbsp;
                    </strong>
                    We may process your information to respond to your inquiries
                    and solve any potential issues you might have with the
                    requested service.
                    <br />
                    <br />
                    <strong>
                      To&nbsp;uphold an individual's vital interest.
                    </strong>
                    &nbsp;We may process your information when necessary to
                    uphold an individual’s vital interests during your
                    communications with us.
                    <br />
                    <br />
                    <br />
                    <strong>
                      3. WHAT LEGAL BASES DO WE RELY ON&nbsp;TO PROCESS YOUR
                      INFORMATION?
                    </strong>
                    <br />
                    <br />
                    We may rely on the following legal bases to process your
                    personal information:
                    <br />
                    <br />
                    <strong>Consent.&nbsp;</strong>We may process your
                    information if you have given us permission
                    (i.e.,&nbsp;consent) to use your personal information for a
                    specific purpose. You can withdraw your consent at any time.
                    <br />
                    <br />
                    <strong>Performance&nbsp;of a Contract.</strong>&nbsp;We may
                    process your personal information when we believe it is
                    necessary to&nbsp;fulfil&nbsp;our contractual obligations to
                    you, including providing our Services or at your request
                    prior to entering into a contract with you.
                    <br />
                    <br />
                    <strong>Legal&nbsp;Obligations.</strong>&nbsp;We may process
                    your information where we believe it is necessary for
                    compliance with our legal obligations, such as to cooperate
                    with a law enforcement body or regulatory agency, exercise
                    or defend our legal rights, or disclose your information as
                    evidence in litigation in which we are involved.
                    <br />
                    <br />
                    <strong>Vital&nbsp;Interests.</strong>&nbsp;We may process
                    your information where we believe it is necessary to protect
                    your vital interests or the vital interests of a third
                    party, such as situations involving potential threats to the
                    safety of any person.
                    <br />
                    <br />
                    <br />
                    <strong>
                      4. WHEN AND WITH WHOM DO WE SHARE&nbsp;YOUR PERSONAL
                      INFORMATION?
                    </strong>
                    <br />
                    <br />
                    We&nbsp;may need to share your personal information in the
                    following situations:
                    <br />
                    <br />
                    <strong>Business&nbsp;Transfers.</strong>&nbsp;We may share
                    or transfer your information in connection with, or during
                    negotiations of, any merger, sale of company assets,
                    financing, or acquisition of all or a portion of our
                    business to another company.
                    <br />
                    <br />
                    <strong>Affiliates.&nbsp;</strong>We may share your
                    information with our affiliates, in which case we will
                    require those affiliates to&nbsp;honor&nbsp;this privacy
                    notice. Affiliates include our parent company and any
                    subsidiaries, joint venture partners, or other companies
                    that we control or that are under common control with us.
                    <br />
                    <br />
                    <strong>
                      5. HOW LONG DO WE KEEP YOUR&nbsp;INFORMATION?
                    </strong>
                    <br />
                    <br />
                    <strong>•&nbsp;</strong>We will only keep your personal
                    information for as long as it is necessary for the purposes
                    set out in this privacy notice.
                    <br />
                    <br />
                    <strong>•&nbsp;</strong>When we have no ongoing legitimate
                    business need to process your personal information, we will
                    either delete or&nbsp;anonymize&nbsp;such information, or,
                    if this is not possible (for example, because your personal
                    information has been stored in backup archives), then we
                    will securely store your personal information and isolate it
                    from any further processing until deletion is possible.
                    <br />
                    <br />
                    <strong>
                      6. HOW DO WE KEEP YOUR INFORMATION&nbsp;SAFE?
                    </strong>
                    <br />
                    <br />
                    We have implemented appropriate and reasonable technical
                    and&nbsp;organizational&nbsp;security measures designed to
                    protect the security of any personal information we process.
                    However, despite our safeguards and efforts to secure your
                    information, no electronic transmission over the Internet or
                    information storage technology can be guaranteed to be 100%
                    secure, so we cannot promise or guarantee that hackers,
                    cybercriminals, or other&nbsp;unauthorized&nbsp;third
                    parties will not be able to defeat our security and
                    improperly collect, access, steal, or modify your
                    information. Although we will do our best to protect your
                    personal information, transmission of personal information
                    to and from our Services is at your own risk. You should
                    only access the Services within a secure environment.
                    <br />
                    <br />
                    <strong>
                      7. DO WE COLLECT INFORMATION FROM&nbsp;MINORS?
                    </strong>
                    <br />
                    <br />
                    We do not knowingly solicit data from or market to children
                    under 18 years of age. By using the Services, you represent
                    that you are at least 18 or that you are the parent or
                    guardian of such a minor and consent to such minor
                    dependent’s use of the Services. If we learn that personal
                    information from users less than 18 years of age has been
                    collected, we will take reasonable measures to promptly
                    delete such data from our records. If you become aware of
                    any data we may have collected from children under age 18,
                    please contact us at&nbsp;
                    <a href="mailto:team@minuszero.in">team@minuszero.in</a>.
                    <br />
                    <br />
                    <strong>
                      If you have questions or comments about your privacy
                      rights, you may email us at&nbsp;
                    </strong>
                    <a href="mailto:team@minuszero.in">
                      <strong>team@minuszero.in</strong>
                    </a>
                    <strong>.</strong>
                    <br />
                    <br />
                    <strong>8. TRACK FEATURES</strong>
                    <br />
                    <br />
                    Currently, we do not track cookies, IP, location or any
                    unvoluntary user data when you visit our website, unless you
                    voluntarily choose to contact us. If any policy for online
                    tracking is adopted by us in the future, we will inform you
                    about that practice in a revised version of this privacy
                    notice.
                    <br />
                    <br />
                    <strong>9. LINKS TO OTHER WEBSITES</strong>
                    <br />
                    <br />
                    Our Service may contain links to other websites that are not
                    operated by Us. If You click on a third-party link, you will
                    be directed to that third party's site. We strongly advise
                    You to review the Privacy Policy of every site You visit.
                    <br />
                    <br />
                    We have no control over and assume no responsibility for the
                    content, privacy policies or practices of any third-party
                    sites or services.
                    <br />
                    <br />
                    <br />
                    <strong>10. DO WE MAKE UPDATES TO THIS&nbsp;NOTICE?</strong>
                    <br />
                    <br />
                    We may update this privacy notice from time to time. The
                    updated version will be indicated by an
                    updated&nbsp;"Revised"&nbsp;date and the updated version
                    will be effective as soon as it is accessible. If we make
                    material changes to this privacy notice, we may notify you
                    by posting a notice of such changes. We encourage you to
                    review this privacy notice frequently to be informed of how
                    we are protecting your information.
                    <br />
                    <br />
                    <br />
                    <strong>
                      11. HOW CAN YOU CONTACT US ABOUT&nbsp;THIS NOTICE?
                    </strong>
                    <br />
                    <br />
                    If you have questions or comments about this notice, you
                    may&nbsp;email us at&nbsp;
                    <a href="mailto:team@minuszero.in">team@minuszero.in</a>
                    &nbsp;or by post to:
                    <br />
                    <br />
                    Minus Zero Robotics Private Limited
                    <br />
                    3rd Floor, 240/A, 27th Main, 2nd Sector,
                    <br />
                    HSR Layout, Bengaluru, India - 560102
                    <br />
                    </div>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="row justify-content-center align-items-center"
              data-aos="flip-up"
              data-aos-duration="400"
              style={{ paddingBottom: "40px" }}
            >
              <div className="col-auto col-sm-12 col-md-7 col-lg-10 col-xl-8 col-xxl-8 offset-xl-0 offset-xxl-0 align-self-start">
                <a href="https://www.linkedin.com/in/gagandeepreehal/"></a>
                <a
                  href="mailto:ceo@minuszero.in"
                  style={{ color: "rgb(160, 157, 155)" }}
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{background:"black"}}>

      <Footer/>
      </div>
    </>
  );
};

export default Privacy;
